function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.00926 51.5579C8.45371 51.5724 7.89815 51.4124 7.49075 51.085L0.592609 45.6361C-0.203686 45.0104 -0.194426 43.9992 0.601869 43.3736C1.39816 42.7479 2.6852 42.7552 3.4815 43.3808L6.90742 46.0798L6.90742 2.14651C6.90742 1.25896 7.81483 0.546021 8.94445 0.546021C10.0741 0.546021 10.9815 1.25896 10.9815 2.14651L10.9815 46.189L14.5278 43.4027C15.3241 42.777 16.6111 42.777 17.4074 43.4027C17.8056 43.7155 18 44.1229 18 44.5376C18 44.945 17.8056 45.3596 17.4074 45.6724L10.5093 51.0923C10.0926 51.4124 9.5463 51.5651 9.00926 51.5579Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -0.00000144248,
  y1: 26.0524,
  x2: 18,
  y2: 26.0524,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.217838,
  stopColor: "#85FFBD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFFB7D"
})));

function SvgScrollArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 52,
    viewBox: "0 0 18 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollArrow);
export default __webpack_public_path__ + "static/media/scroll-arrow.d178a261.svg";
export { ForwardRef as ReactComponent };